import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { positionDropdown } from '../../../../common/dropdown'
import { selectDataPortfolioAll } from '../../../../common/filterCompany/store/slicePortfolio'
import { UseI18n } from '../../../../common/hooks/useI18n'
import { SelectCustom } from '../../../../common/selectCustom'
import { removeAccents } from '../../../../helpers/common'
import { PORTFOLIO_SCROLL_ID } from '../../../common/Layout'
import { changeData } from '../store/slice'
import classes from './index.module.scss'

export const SelectSearch = ({ activePortfolio, keyPort }) => {
  const dispatch = useDispatch()

  const data = useSelector(selectDataPortfolioAll)

  const textPlaceholder = UseI18n('portfolio.finance.SELECT_PORTFOLIO')

  const [inputValue, setInputValue] = useState(
    activePortfolio?.value ? activePortfolio?.label : '',
  )

  const listDrop = [
    { label: 'portfolio.finance.BLANK', value: undefined, isI18n: true },
    ...data.filter((item) =>
      removeAccents(item.label.toLowerCase()).includes(
        removeAccents(inputValue.trim().toLowerCase()),
      ),
    ),
  ]

  const onChooseItem = (item) => {
    dispatch(
      changeData({
        path: ['activePort', keyPort],
        data: item,
      }),
    )
    !!item?.value && setInputValue(item.label)
  }

  const onFocus = () => {
    setInputValue('')
  }

  const handleClickOutside = () => {
    setInputValue(activePortfolio?.value ? activePortfolio?.label : '')
  }

  return (
    <>
      <SelectCustom
        renderActiveItem={(item) => (
          <input
            value={inputValue}
            className={classes.input}
            onChange={(e) => setInputValue(e.target.value)}
            placeholder={textPlaceholder}
            style={{ backgroundColor: 'transparent' }}
            onFocus={onFocus}
          />
        )}
        activeItem={activePortfolio}
        data={data.length ? listDrop : []}
        isBorderNone
        styleDropdown={{ maxWidth: 400 }}
        dropdownPosition={positionDropdown.BOTTOM_END_LEFT}
        scrollId={PORTFOLIO_SCROLL_ID}
        chooseItem={onChooseItem}
        style={{ paddingLeft: 0 }}
        handleClickOutside={handleClickOutside}
      />
    </>
  )
}
